export default __webpack_public_path__ + "static/media/ic_across.647e2187.svg";